import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { NativeSelect } from "@/components/common";
import { api, errMsg } from "@/lib/api";

const LABEL = { none: "Tidak diizinkan", all: "Semua perusahaan", some: "Perusahaan tertentu" };

export function RevisionScopeButton({ user, tenants, onDone }) {
  const [open, setOpen] = useState(false);
  const cur = user.revision_scope || { mode: "none", tenants: [] };
  const [mode, setMode] = useState(cur.mode);
  const [sel, setSel] = useState(new Set(cur.tenants));
  useEffect(() => {
    if (open) { setMode(cur.mode); setSel(new Set(cur.tenants)); }
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  const save = async () => {
    try {
      await api.put(`/admin/users/${user.id}/revision-scope`, { mode, tenants: [...sel] });
      toast.success("Izin revisi disimpan & tercatat di audit log");
      setOpen(false);
      onDone();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <>
      <Button size="sm" variant="outline" className="h-7 text-[11px]" onClick={() => setOpen(true)} data-testid={`rev-scope-btn-${user.username}`}>Izin Revisi: {LABEL[cur.mode]}{cur.mode === "some" ? ` (${cur.tenants.length})` : ""}</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid="rev-scope-dialog">
          <DialogHeader>
            <DialogTitle>Izin Revisi Invoice · {user.username}</DialogTitle>
            <DialogDescription>Supervisor yang diizinkan dapat menyetujui/menolak pengajuan dan mengedit langsung invoice yang sudah disahkan.</DialogDescription>
          </DialogHeader>
          <NativeSelect value={mode} onChange={(e) => setMode(e.target.value)} className="w-full h-11" data-testid="rev-scope-mode">
            {Object.entries(LABEL).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </NativeSelect>
          {mode === "some" && (
            <div className="max-h-60 overflow-y-auto space-y-1 border rounded-sm p-2">
              {tenants.map((t) => (
                <label key={t.id} className="flex items-center gap-2 text-sm py-1">
                  <Checkbox checked={sel.has(t.id)} onCheckedChange={() => setSel((s) => { const n = new Set(s); if (n.has(t.id)) n.delete(t.id); else n.add(t.id); return n; })} data-testid={`rev-scope-tenant-${t.code || t.id}`} />{t.name}
                </label>
              ))}
            </div>
          )}
          <DialogFooter><Button onClick={save} disabled={mode === "some" && sel.size === 0} className="h-11 bg-emerald-700 hover:bg-emerald-800" data-testid="rev-scope-save">Simpan</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
